export const YEAR_DECADE_COUNT = 10;
